export default "__VITE_ASSET__CzgYjy99__"